import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { JobsService } from '@app/shared/jobs.service';

@Component({
  styleUrls: ['./apply-now.component.css'],
  templateUrl: './apply-now.component.html',
})
export class ApplyNowComponent implements OnInit, OnDestroy {
  domicileId: number;
  isLoading = true;
  jobExperience: string;
  jobId: string;
  jobTitle: string;
  recordSource: string;

  constructor(private activatedRoute: ActivatedRoute, private jobsService: JobsService) {}

  ngOnDestroy(): void {}

  ngOnInit() {
    const jobId = this.activatedRoute.snapshot.paramMap.get('id');
    const city = this.activatedRoute.snapshot.paramMap.get('city');
    const state = this.activatedRoute.snapshot.paramMap.get('state');
    this.recordSource = this.activatedRoute.snapshot.paramMap.get('recordSource');

    if (jobId) {
      this.jobId = jobId;
      this.jobsService
        .jobById(parseInt(jobId, 10), city, state) // 10 = decimal
        .then((apiJob) => {
          this.jobExperience = apiJob.experience;
          this.jobTitle = apiJob.title;
          this.domicileId = apiJob.domicileId;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
